import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import ElementUI from 'element-ui';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 阿里图标库
import "@/assets/icon/iconfont.css";
import store from './store/store.js'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import i18n from './i18n'
const IS_TEST = true
const TOKEN_KEY = 'tikotToken'


Vue.config.productionTip = false
Vue.use(ElementUI, {
    size: 'small'
});

// console.log(_TOKEN)

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    // console.log(to);
    // console.log(from);
    if(to.meta.label == 'topage' && from.meta.label != 'joinpage')
    {
      next('/index/joinpage');
    }
    if(to.meta.login === true && !window.localStorage.getItem(TOKEN_KEY))
    {
      next('/user/login');
      // next();
    }else if((to.meta.label=='cashout' && from.meta.label=='addbank')){
      next('/user/main');
    }
    else if( (to.meta.label=='bank' && from.meta.label=='addbank')){
      next('/user/main/security');
    }else{
      next();
    }
    // console.log(from);
    // console.log(next.path);

});

new Vue({
  render: h => h(App),
  router,
  store,
  i18n
})
.$mount('#app')
